 
import { useEffect, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from 'react-router-dom';
import { useDispatch, connect } from 'react-redux';

import type * as statuses from 'services/store/states';
import verifyToken from 'services/store/features/roles/actions';

import Loading from 'components/library/Loading';
import Eligible from 'views/Eligible';
import InvoicingForm from 'views/InvoicingForm';
import DownloadInvoice from 'views/DownloadInvoice';

import type { AppDispatch, RootState } from 'services/store/types';

type RouteProps = {
  path: string,
  auth: boolean,
  component: any,
};

const ROUTES: RouteProps[] = [
  {
    path: '/invoicingForm',
    component: InvoicingForm,
    auth: true,
  },
  {
    path: '/downloadInvoice',
    component: DownloadInvoice,
    auth: true,
  },
  {
    path: '/',
    component: Eligible,
    auth: false,
  },
];


function RouteWithSubRoutes({
  status, route,
}: { status: typeof statuses[keyof typeof statuses], route: RouteProps }) {
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    dispatch(verifyToken(route.auth));
  }, [route.auth, dispatch]);

  if (route.auth && status !== 'SUCCEEDED') {
    return <Loading />;
  }
  return (
    <route.component />
  );
}

const mapStateToProps = (state: RootState) => ({
  status: state.roles?.status,
});

const ConnectedRouteWithSubRoutes = connect(mapStateToProps)(RouteWithSubRoutes);

export default function RouteConfig() {
  return (
    <Router>
      <div className="main">
        <Suspense fallback={<Loading />}>
          <Routes>
            {ROUTES.map((route) => (
              <Route key={route.path} path={route.path} element={<ConnectedRouteWithSubRoutes route={route} />} />
            ))}
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}
